import { render } from "./FindTempPassword.vue?vue&type=template&id=ab4e8786"
import script from "./FindTempPassword.vue?vue&type=script&lang=js"
export * from "./FindTempPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__